import { DownloadOutlined, UploadOutlined } from "@ant-design/icons";
import { Button, Card, Col, Form, Input, Row, Upload } from "antd";
import React, { useEffect, useState } from "react";
import { authenticateToken } from "../../utils/auth";
import { responseNotification } from "../../utils/notify";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import ImageUploader from "../FileManager/upload";

// @ts-ignore
import builkcsv from "../../demo-files/mail.csv";
import * as d3 from "d3";

type CSVData = {
  emailAddresses: string[];
};

const EmailNotification = () => {
  const [generatedImgUrl, setGeneratedImgUrl] = useState<string>();
  const [startUpload, setStartUpload] = useState<
    "Initiated" | "Uploading" | "Uploaded"
  >(undefined);
  const [loading, setLoading] = useState(false);
  const [fetchedCSVData, setFetchedCSVdata] = useState<CSVData | null>();
  const [convertedText, setConvertedText] = useState("");

  const [form] = Form.useForm();

  useEffect(() => {
    if (startUpload === "Uploaded") {
      form.submit();
    }
  }, [form, startUpload]);

  const onSubmit = async (data) => {
    setLoading(true);
    const readyData = data && {
      subject: data.subject,
      from: '"ডাঃ সায়মা আফরোজ ইভা - UHFPO Forum Election"<dr.saimaafrozeva@gmail.com>',
      body: ``,
      // body: `<!DOCTYPE html>\n<html lang=\"en\">\n<head>\n<meta charset=\"UTF-8\">\n<title>\`${
      //   data.subject
      // }\`</title>\n</head>\n<body>\`<div>${convertedText}</div>${
      //   generatedImgUrl
      //     ? `<img src=\"${generatedImgUrl}\" alt=\"${data.subject}\" width=\"500\" >`
      //     : ``
      // }\`\n</body>\n</html>`,
      emailAddresses:
        fetchedCSVData?.emailAddresses?.filter((item) => item) || [],
    };

    await fetch(`${process.env.REACT_APP_NOTIFICATION_API}/email/bulk`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${authenticateToken()}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(readyData),
    })
      .then((res) => res.json())
      .then((res) => {
        setLoading(false);

        if (res.statusCode === 200) {
          responseNotification("Mail Sent Successfully", "success");
          resetData();
        } else if (res.status === 500) {
          responseNotification("Internal server error", "error");
        } else {
          responseNotification(res.message || "something wrong", "warning");
        }
      })
      .catch((err) => {
        setLoading(false);
        responseNotification(`${"Internal server error"} ${err}`, "error");
        console.error("err", err);
      });
  };

  const resetData = () => {
    form?.resetFields();
    setFetchedCSVdata(null);
    setConvertedText("");
  };

  const simpleFileDownload = () => {
    window.location.href = `${builkcsv}`;
  };

  const handleUpload = async (data) => {
    const filteredData = [];
    console.log("emails", data);
    const regex =
      /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

    data?.forEach((row) => {
      const email = row.emailAddresses;
      if (regex.test(email)) {
        filteredData.push(email);
      } else {
        filteredData.push(undefined);
      }
    });
    setFetchedCSVdata({
      emailAddresses: filteredData,
    });
  };

  const readUploadFile = (val) => {
    const mainFile = val.fileList[0].originFileObj;

    if (mainFile) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = e.target.result;
        d3.csv(data).then((res) => {
          handleUpload(res);
          console.log("Contacts:", res);
        });
      };
      reader.readAsDataURL(mainFile);
    }
  };

  return (
    <React.Fragment>
      <div style={{ overflowY: "auto", height: "calc(100vh - 150px)" }}>
        <Row
          gutter={25}
          align="middle"
          justify="center"
          className="product-table"
        >
          <Col span={12}>
            <Card
              title="Send Mail"
              extra={
                <Button
                  onClick={simpleFileDownload}
                  type="dashed"
                  shape="round"
                >
                  <DownloadOutlined />
                  Sample File
                </Button>
              }
            >
              <Form layout="vertical" onFinish={onSubmit} form={form}>
                <Form.Item
                  hasFeedback
                  label="Subject"
                  name="subject"
                  rules={[
                    {
                      required: true,
                      message: "Subject is required",
                    },
                  ]}
                >
                  <Input id="subject" placeholder="Enter Subject" />
                </Form.Item>

                <ReactQuill
                  theme="snow"
                  value={convertedText}
                  onChange={setConvertedText}
                  style={{
                    minHeight: "200px",
                    width: "100%",
                    marginBottom: 60,
                  }}
                />

                <h4 className="title" style={{ maxWidth: "99%" }}>
                  Image:
                </h4>
                <div className="">
                  <ImageUploader
                    imgUrl={generatedImgUrl || ""}
                    startUpload={startUpload}
                    setStartUpload={(val: any) => setStartUpload(val)}
                    setGeneratedImgUrl={(url: any) => setGeneratedImgUrl(url)}
                  />
                </div>

                <div className="my-4">
                  <Form.Item
                    hasFeedback
                    label=""
                    name="upload"
                    rules={[
                      {
                        required: true,
                        message: "File is required",
                      },
                    ]}
                  >
                    <Upload onChange={readUploadFile}>
                      <Button
                        type="dashed"
                        size="large"
                        shape="round"
                        danger
                        htmlType="button"
                        icon={<UploadOutlined />}
                      >
                        Upload Contacts (.csv)
                      </Button>
                    </Upload>
                  </Form.Item>
                </div>

                {fetchedCSVData?.emailAddresses?.length >= 0 && (
                  <div className="mb-2 txt-red accent-txt">
                    Uploaded{" "}
                    {
                      fetchedCSVData?.emailAddresses?.filter((item) => item)
                        ?.length
                    }{" "}
                    Valid Contacts
                  </div>
                )}
                {fetchedCSVData?.emailAddresses?.length !==
                  fetchedCSVData?.emailAddresses?.filter((item) => item)
                    ?.length && (
                  <div className="mb-2 txt-red accent-txt">
                    Error in{" "}
                    {fetchedCSVData?.emailAddresses?.length -
                      fetchedCSVData?.emailAddresses?.filter((item) => item)
                        ?.length}{" "}
                    (row-
                    {fetchedCSVData?.emailAddresses?.map((item, i) =>
                      item === undefined ? i + 1 : undefined
                    )}
                    ) email addresses
                  </div>
                )}

                <div className="buttons-container">
                  <Button
                    disabled={
                      loading || !fetchedCSVData?.emailAddresses?.length
                    }
                    loading={(loading ? "loading" : undefined) as any}
                    type="primary"
                    htmlType="submit"
                    className="add-submit-btn text-center mr-2"
                    onClick={(e) => {
                      e.preventDefault();
                      setStartUpload("Uploading");
                    }}
                  >
                    Send Mail
                  </Button>
                  <Button
                    type="ghost"
                    htmlType="button"
                    onClick={() => {
                      resetData();
                      setGeneratedImgUrl(undefined);
                      setStartUpload(undefined);
                    }}
                    className="reset-submit-btn text-center mr-2"
                  >
                    Reset
                  </Button>
                </div>
              </Form>
            </Card>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  );
};

export default EmailNotification;
